import { Redirect } from 'react-router';
import { providerChartsReviewRoute, providerSuperviseeChartsReviewRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useCollaboratePhysicianMatchQuery, useCollaborativeChartsReviewForMatchQuery } from '@uplift/queries';
import { ProviderLayout } from '@uplift/ui-v2';


const SuperviseeChartsReviewProxyPageContent = () => {
  const { collaborativeMatchId } = providerSuperviseeChartsReviewRoute.useParams();
  const { data: collaborativeMatch } = useCollaboratePhysicianMatchQuery(collaborativeMatchId);
  const { data: chartsReview } = useCollaborativeChartsReviewForMatchQuery(collaborativeMatchId);

  if (!collaborativeMatch) {
    return <Redirect to={ROUTING_CONFIG.supervisees} />;
  }

  if (!chartsReview) {
    return <Redirect to={ROUTING_CONFIG.supervisees} />;
  }

  return <Redirect to={providerChartsReviewRoute.createLink({ reviewId: chartsReview.id })} />;
};


export const SuperviseeChartsReviewProxyPage: React.VFC = () => {
  return (
    <ProviderLayout>
      <SuperviseeChartsReviewProxyPageContent />
    </ProviderLayout>
  );
};
